import React from 'react'
import { Label } from 'semantic-ui-react'

export const ChipDrawer = ({ selected, handleDeselectChip }) => {
  return (
    <div className='filter-chips'>
      {selected && selected.some((s) => s.values.length > 0) ? (
        <React.Fragment>
          <span className='appliedLabel'>Applied Filters</span>
          <div>
            {selected.map((sFilter, i) =>
              sFilter.values.length > 0 ? (
                <Label
                  key={i}
                  circular={true}
                  color='pink'
                  style={{ padding: '.5em .7em' }}
                >
                  {sFilter.title}:{' '}
                  {sFilter.values.length > 3
                    ? `(${sFilter.values.length})`
                    : sFilter.values.join(', ')}{' '}
                  <button
                    style={{
                      outline: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      margin: 0,
                      padding: '0 0 0 5px',
                      fontWeight: 800,
                      fontSize: '16px'
                    }}
                    onClick={() => handleDeselectChip({ name: sFilter.name })}
                  >
                    &times;
                  </button>
                </Label>
              ) : null
            )}
          </div>
        </React.Fragment>
      ) : (
        <span className='noFilters'>No filters have been applied.</span>
      )}
    </div>
  )
}

export default ChipDrawer
